import * as React from 'react';
import LightBulb from '../assets/SVG/LightBulb';
import { SPLASH_CONTENT } from '../utils/constants';

const Splash = ({ index = 0 }) => {
    const { tag, label, img, content, backgroundColor } = SPLASH_CONTENT[index];

    return (
        <div
            className={`w-full h-full relative flex items-center justify-center ${backgroundColor} p-10`}
        >
            <img src={img} className="object-contain h-full" />
            <div className="absolute left-8 bottom-8 rounded-lg p-4 bg-white/70 lg:w-4/5 2xl:w-3/5 max-w-max">
                <div className="font-bold mb-1 text-lg flex items-center">
                    <span className="flex gap-2 items-center mr-1">
                        <LightBulb />
                        {tag && `${tag}:`}
                    </span>
                    <span>{label}</span>
                </div>
                <p>{content}</p>
            </div>
        </div>
    );
};

export default Splash;
